import { gql } from '@apollo/client';

export * from './oauthReposConn.query.generated';

export const OAUTH_REPOSITORIES = gql`
  query oauthReposConn($integrationId: ID!) {
    oauthReposConn(integrationId: $integrationId) {
      repositories {
        id
        name
        fullName
      }
    }
  }
`;
